// foodmenu/search.jsx
import React from "react";

export default function SearchMenu({ onSearch }) {
  return (
    <div className="search-bar-container">
      <input
        type="text"
        placeholder="🔍 Search items..."
        className="search-bar"
        onChange={(e) => onSearch(e.target.value)}
      />
    </div>
  );
}
